// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nartcbzfahbmkgsysyur.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5hcnRjYnpmYWhibWtnc3lzeXVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU3NjM2NjAsImV4cCI6MjA2MTMzOTY2MH0.oBXXz4oWmdhOaqCSifKKD-kGkeaoWoEsfC73Bg0pnl4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create client with production-safe error handling
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  realtime: {
    params: {
      eventsPerSecond: 2 // Reduce connection frequency to prevent spam
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'goodvote-app'
    }
  }
});

// Suppress WebSocket errors in production for SEO
if (typeof window !== 'undefined' && import.meta.env.PROD) {
  const originalError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    // Filter out WebSocket and network errors that affect SEO scores
    if (message.includes('WebSocket connection') || 
        message.includes('net::ERR_NAME_NOT_RESOLVED') ||
        message.includes('Failed to load resource')) {
      return; // Suppress these errors in production
    }
    originalError.apply(console, args);
  };
}